"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusPill = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const StatusPillSection = (0, styled_components_1.default)(base_react_components_1.Text).withConfig({ displayName: "reports-StatusPillSection", componentId: "reports-to5llo" }) `
  display: inline-block;
  text-align: center;
  background-color: ${({ theme, status }) => theme[status]};
  padding: 8px 32px;
  color: ${({ theme }) => theme.white};
  font-size: 32px;
  line-height: 1;
  border-radius: 8px;
`;
const StatusPill = (_a) => {
    var { value, status } = _a, props = __rest(_a, ["value", "status"]);
    return (react_1.default.createElement(StatusPillSection, Object.assign({}, props, { status: status }), value));
};
exports.StatusPill = StatusPill;
exports.default = exports.StatusPill;
//# sourceMappingURL=index.js.map